import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'secure-layout',
    templateUrl: './secure-layout.component.html',
    styleUrls: ['./secure-layout.component.scss']
})
export class SecureLayoutComponent extends BaseComponent {
    constructor(private route: ActivatedRoute, private router: Router) {
        super(route);
  }

  logout() {
    localStorage.removeItem('authToken');
    this.router.navigateByUrl('/login');
  }
}
